import './Modal.css';
export var backdrop = '_dmotjm4-3-5-0';
export var base = '_dmotjm0-3-5-0';
export var header = '_dmotjm5-3-5-0';
export var sizes = {small:'_dmotjm1-3-5-0',medium:'_dmotjm2-3-5-0',large:'_dmotjm3-3-5-0'};